var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board"},[(!_vm.invalidsExist && _vm.noQueensAvailable)?_c('Success'):_vm._e(),_vm._l((8),function(i){return _c('Row',{key:i,attrs:{"index_x":i-1}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }